/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_View_CompanyInputs */

const en_admin_registration_view_company = /** @type {(inputs: Admin_Registration_View_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Company`)
};

const de_admin_registration_view_company = /** @type {(inputs: Admin_Registration_View_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen ansehen`)
};

/**
* | output |
* | --- |
* | "View Company" |
*
* @param {Admin_Registration_View_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_view_company = /** @type {((inputs?: Admin_Registration_View_CompanyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_View_CompanyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_view_company(inputs)
	return en_admin_registration_view_company(inputs)
});